import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e8e5614"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "card-box" }
const _hoisted_3 = { class: "project-title" }
const _hoisted_4 = { class: "step-list" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "black" }
const _hoisted_10 = { class: "line" }
const _hoisted_11 = {
  key: 0,
  class: "iconfont"
}
const _hoisted_12 = { class: "log-list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "left-box" }
const _hoisted_15 = { class: "right-box" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "black" }
const _hoisted_18 = { class: "time grey" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 汇报时间 ")
const _hoisted_20 = { class: "desc grey" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 汇报详情 ")

import { getProjectLogList, getItemDetail } from '@/apis/projectDetail'
import { onMounted, ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import _lodash from '@/utils/lodashUtil'
import { Toast } from 'vant'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = reactive({
  page: 1,
  tabsActive: 5,
  stage: 0, // 禁用状态
  stageId: 1,
  projectLogList: []
})
const router = useRouter()
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const AcceptanceDetails = ref({})

const projectId = ref(null)
const projectname = ref(null)

const get_Acceptance = async () => {
  let data = {
    type: 8,
    project_id: projectId.value
  }
  const res = await getItemDetail(data)
  if (res.code === 200) {
    let data = {
      tab_number: 3,
      type_name: '项目验收',
      created_at: res.data.created_at,
      content: res.data.explain,
      item_id: res.data.id
    }
    AcceptanceDetails.value = res.data
    state.projectLogList.push(data)
  }
}

const to_details = async e => {
  if (e.hasOwnProperty('tab_number')) {
    if (e.tab_number === 0) {
      router.push('declare-info')
    }
    if (e.tab_number === 3) {
      // let data = JSON.stringify(AcceptanceDetails.value)
      let req = {
        type: 8,
        item_id: e.item_id,
        project_id: projectId.value
      }
      const res = await getItemDetail(req)
      let data = JSON.stringify(res.data)

      router.push('acceptance-info?data=' + data + '&type_name=' + e.type_name)
    }
  } else {
    console.log('类型===>', e.type)
    let data = {
      type: e.type,
      item_id: e.item_id
      // project_id: projectId.value
    }
    const res = await getItemDetail(data)
    if (res.code === 200) {
      // delete res.data  删除res.data 测试 下方功能
      if (!res.data) {
        Toast('暂无详情数据')
        return false
      }
      let data = JSON.stringify(res.data)
      switch (e.type) {
        case 1:
          router.push('expense-declaration/detail?data=' + data + '&type_name=' + e.type_name)
          break
        case 2:
          console.log('项目终止')
          router.push('project-termination/detail?data=' + data + '&type_name=' + e.type_name)
          break
        case 3:
          console.log('项目回款')
          router.push('payment-collection/detail?data=' + data + '&type_name=' + e.type_name)
          break
        case 4:
          console.log('合同上传')
          router.push('uploadcontract-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 5:
          console.log('补充协议')
          router.push('replenish-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 6:
          console.log('施工申请')
          router.push('construction-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 7:
          console.log('发货申请')
          router.push('sendapply-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 8:
          console.log('项目验收')
          // router.push('sendapply-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 9:
          console.log('完结申请')
          router.push('completeapply-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 10:
          console.log('施工进度汇报')
          router.push('schedule-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 11:
          console.log('施工进度汇报')
          router.push('schedule-info?data=' + data + '&type_name=' + e.type_name)
          break
        case 12:
          console.log('进度汇报')
          router.push('progress-report/detail?data=' + data + '&type_name=' + e.type_name)
          break
        case 13:
          console.log('拜访记录')
          router.push('visit-record/detail?data=' + data + '&type_name=' + e.type_name)
          break
        default:
          return
      }
      // if (e.type === 1) {
      //   router.push('expense-declaration/detail?data=' + res.data)
      // }
    }
  }
}

const onClickTab = (value: { name: number; title: string; disabled: boolean }) => {
  console.log(value)
  if (!value.disabled) {
    if (value.name == 0) {
      state.projectLogList = []
      let details = JSON.parse(localStorage.getItem('PROJECT_DETAIL'))
      let data = {
        tab_number: 0,
        type_name: '项目申报',
        created_at: details.created_at,
        content: details.project_name
      }
      state.projectLogList.push(data)
    } else if (value.title === '验收阶段') {
      console.log('验收阶段')
      state.projectLogList = []
      get_Acceptance()
    } else if (value.title === '收尾阶段') {
      state.projectLogList = []
      state.stageId = value.name - 1
      onRefresh()
      get_ProjectLog()
    } else {
      console.log('all')
      state.projectLogList = []
      state.stageId = value.name
      onRefresh()
      get_ProjectLog()
    }
  }
}

const get_ProjectLog = async () => {
  let data = {
    page_size: 10,
    page: state.page,
    stage: state.stageId,
    project_id: projectId.value
  }
  const res = await getProjectLogList(data)
  if (res.code === 200) {
    finished.value = false
    if (refreshing.value) {
      state.projectLogList = []
      refreshing.value = false
    }
    state.page += 1

    state.projectLogList = _lodash.uniq(_lodash.concat(state.projectLogList, res.data.data))

    loading.value = false
    if (state.page > res.data.last_page) {
      // 已到最后一页
      finished.value = true
    }
  }
}

const get_ProjectLog1 = async () => {
  let data = {
    stage: state.stageId,
    project_id: projectId.value
  }
  const res = await getProjectLogList(data)
  if (res.code === 200) {
    state.projectLogList = res.data
  }
}
const onRefresh = () => {
  // 清空列表数据
  finished.value = false
  state.page = 1
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  // get_ProjectLog()
}

onMounted(() => {
  let projectInfo = JSON.parse(localStorage.getItem('PROJECT_DETAIL'))
  state.stage = projectInfo.stage
  console.log(state.stage)
  projectId.value = router.currentRoute.value.query.project_id
  projectname.value = router.currentRoute.value.query.project_name
  if (projectInfo.stage == 3) {
    state.tabsActive = projectInfo.stage + 1
    state.stageId = projectInfo.stage
  } else if (projectInfo.stage == 4) {
    state.tabsActive = projectInfo.stage
    state.stageId = projectInfo.stage - 1
  } else {
    state.tabsActive = projectInfo.stage
    state.stageId = projectInfo.stage
  }
})

const steps = ref([
  {
    img: '&#xe794;',
    name: '申报阶段'
  },
  {
    img: '&#xe63a;',
    name: '跟进阶段'
  },
  {
    img: '&#xe662;',
    name: '施工阶段'
  },
  {
    img: '&#xe65a;',
    name: '验收阶段'
  },
  {
    img: '&#xe65f;',
    name: '收尾阶段'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(projectname.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_tabs, {
          active: _unref(state).tabsActive,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).tabsActive) = $event)),
          color: "#2A82E4",
          onClickTab: onClickTab
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_van_tab, {
                  title: item.name,
                  disabled: index >= 5 ? true : false
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("i", {
                            class: "iconfont",
                            innerHTML: item.img
                          }, null, 8, _hoisted_8)
                        ]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (index < steps.value.length - 1)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_11, ""))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["title", "disabled"])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ]),
    _createVNode(_component_van_list, {
      loading: loading.value,
      "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
      finished: finished.value,
      "finished-text": "没有更多了",
      onLoad: get_ProjectLog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).projectLogList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "log-item row",
              key: index,
              onClick: ($event: any) => (to_details(item))
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: _normalizeClass(["left-dot", { active: !index }])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.type_name), 1),
                  _createVNode(_component_van_icon, { name: "arrow" })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", null, _toDisplayString(item.created_at), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", null, _toDisplayString(item?.content || '暂无'), 1)
                ])
              ])
            ], 8, _hoisted_13))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["loading", "finished"])
  ]))
}
}

})